import {
  ShieldCheck,
  ClipboardList,
  FileText,
  FileSignature,
  UserMinus,
  ClipboardCheck,
  UserCheck,
  Banknote,
  Presentation,
  Users,
  BookOpen,
  FolderOpen,
} from 'lucide-react';

/**
 * Default HR material sections. The live, editable copy is stored in Firestore
 * (templatesStructures/hr — see services/hrStructureService) and edited from the
 * CRM HR Collections page; these defaults seed/fallback when no doc exists.
 * Each item's `title` maps to a Firestore template doc (templatesCollections) so
 * View/Download resolve a fileUrl, and Tailor passes title + description to the
 * AI customizer. Icons stay client-side, mapped by section id / item title.
 */
export const DEFAULT_HR_SECTIONS = [
  {
    id: 'hiring',
    label: 'Hiring materials',
    items: [
      { title: 'Background Check', name: 'Background Check Consent Form', description: 'Pre-employment background check consent' },
      { title: 'Interview Evaluation', name: 'Interview Evaluation Form', description: 'Score candidates consistently' },
      { title: 'Offer Letter', name: 'Offer Letter', description: 'Extend a professional employment offer' },
      { title: 'Employment Application', name: 'Employment Application', description: 'Standard application for candidates' },
      { title: 'Exit Interview Form', name: 'Exit Interview Form', description: 'Capture feedback from departing employees' },
    ],
  },
  {
    id: 'onboarding',
    label: 'Onboarding resources',
    items: [
      { title: 'New Hire Checklist', name: 'New Hire Checklist', description: 'Every onboarding step in one list' },
      { title: 'New Hire Onboarding', name: 'New Hire Onboarding', description: 'Run a smooth orientation' },
      { title: 'Direct Deposit', name: 'Direct Deposit', description: 'Set up payroll deposits' },
      { title: 'New Hire Presentation', name: 'New Hire Presentation', description: 'Company overview for orientation' },
      { title: 'Employee Referral Program', name: 'Employee Referral Program', description: 'Referral bonus program details' },
      { title: 'Drug Test Consent', name: 'Drug Test Consent', description: 'Pre-employment screening consent' },
      { title: 'Non Compete', name: 'Non Compete', description: 'Standard non-compete agreement' },
    ],
  },
  {
    id: 'handbook',
    label: 'Employee handbook',
    items: [
      { title: 'Employee Handbook', name: 'Employee Handbook', description: 'Company policies & expectations' },
    ],
  },
];

const SECTION_ICONS = {
  hiring: ClipboardList,
  onboarding: UserCheck,
  handbook: BookOpen,
};

const ITEM_ICONS = {
  'Background Check': ShieldCheck,
  'Interview Evaluation': ClipboardList,
  'Offer Letter': FileText,
  'Employment Application': FileText,
  'Exit Interview Form': UserMinus,
  'New Hire Checklist': ClipboardCheck,
  'New Hire Onboarding': UserCheck,
  'Direct Deposit': Banknote,
  'New Hire Presentation': Presentation,
  'Employee Referral Program': Users,
  'Drug Test Consent': ShieldCheck,
  'Non Compete': FileSignature,
  'Employee Handbook': BookOpen,
};

export const getSectionIcon = (sectionId) => SECTION_ICONS[sectionId] || FolderOpen;
export const getItemIcon = (title) => ITEM_ICONS[title] || FileText;

/** Attach display icons to a plain structure loaded from Firestore. */
export const decorateSections = (sections) =>
  sections.map((section) => ({
    ...section,
    icon: getSectionIcon(section.id),
    items: (section.items || []).map((item) => ({ ...item, icon: getItemIcon(item.title) })),
  }));
